import type { Props } from '../type';
import { SVGOutlinedIcon } from './SVGOutlinedIcon';

export const ErrorCircleOutlinedIcon = (props: Props) => (
  <SVGOutlinedIcon color="#F20000" {...props} viewBox="0 0 25 24">
    <path
      d="M12 23.249C18.2132 23.249 23.25 18.2122 23.25 11.999C23.25 5.78582 18.2132 0.749023 12 0.749023C5.7868 0.749023 0.75 5.78582 0.75 11.999C0.75 18.2122 5.7868 23.249 12 23.249Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 16.499L16.5 7.49902"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 16.499L7.5 7.49902"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVGOutlinedIcon>
);
